import {
  createSlice,
  createSelector,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { queryStringFromArray } from "helpers";
import { uncoveryApi } from "services";

const archivedAdapter = createEntityAdapter();
const initialState = archivedAdapter.getInitialState({
  fetchAllArchivedStatus: "idle",
  unarchiveAssetStatus: "idle",
  unarchiveAssetErrorMessage: "",
  hasNextPage: false,
  page: 1,
  pageSize: 50,
  sortBy: "archivedAt",
  orderBy: "desc",
  searchTerm: "",
  count: 0,
  values: [],
  fetchAllArchivedErrorMessage: "",
  isCheckedAll: false,
});

// const options = {
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// };

export const fetchAllArchived = createAsyncThunk(
  "archived/fetchAllArchived",
  async ({ entityId }, { rejectWithValue, getState }) => {
    const { page, pageSize, sortBy, orderBy, searchTerm } = getState().archived;
    const query = `/entities/${entityId}/assets/archived?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&orderBy=${orderBy}&searchTerm=${searchTerm}`;
    try {
      const response = await uncoveryApi.get(query);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const unarchiveAsset = createAsyncThunk(
  "archived/unarchiveAsset",
  async ({ entityId, assetIds }, { rejectWithValue }) => {
    const qsAssetIds = queryStringFromArray(assetIds, "assetId");
    const query = `/entities/${entityId}/assets?${qsAssetIds}`;
    const body = {
      archived: false,
    };
    try {
      const response = await uncoveryApi.put(query, body);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const archivedSlice = createSlice({
  name: "archived",
  initialState,
  reducers: {
    updateSearchTerm: (state, { payload }) => {
      const { searchTerm } = payload;
      state.page = 1;
      state.searchTerm = searchTerm;
      return state;
    },
    sort: (state, { payload }) => {
      const { sortBy } = payload;
      state.page = 1;
      if (sortBy !== state.sortBy) {
        state.orderBy = "asc";
        state.sortBy = sortBy;
      } else {
        state.orderBy = state.orderBy === "desc" ? "asc" : "desc";
      }
      return state;
    },
    updatePage: (state, { payload }) => {
      const { page } = payload;
      state.page = page;
      return state;
    },
    setScrollPosition: (state, { payload }) => {
      const { scrollPosition } = payload;
      state.scrollPosition = scrollPosition;
      return state;
    },
    refreshArchivedStatus: (state) => {
      state.status = "idle";
      return state;
    },
    checkValue: (state, { payload }) => {
      const { assetId } = payload;
      const index = state.values.findIndex((e) => e.id === assetId);
      state.values[index].isChecked = !state.values[index].isChecked;
      return state;
    },
    checkAllValues: (state, { payload }) => {
      const { isChecked } = payload;
      state.isCheckedAll = isChecked;
      state.values.forEach((e) => (e.isChecked = isChecked));
      return state;
    },
    resetArchivedState: () => initialState,
  },
  extraReducers: {
    [fetchAllArchived.pending]: (state, { payload }) => {
      state.fetchAllArchivedStatus = "loading";
    },
    [fetchAllArchived.fulfilled]: (state, { payload }) => {
      payload.data.forEach((e) => {
        e.isChecked = false;
      });
      if (state.page === 1) {
        state.values = payload.data;
      } else {
        state.values = [...state.values, ...payload.data];
      }
      state.hasNextPage = payload.pageInfo.hasNextPage;
      state.count = payload.pageInfo.count;
      state.fetchAllArchivedStatus = "success";
    },
    [fetchAllArchived.rejected]: (state, { payload }) => {
      state.fetchAllArchivedErrorMessage = payload.message;
      state.fetchAllArchivedStatus = "error";
    },
    [unarchiveAsset.pending]: (state) => {
      state.unarchiveAssetStatus = "loading";
    },
    [unarchiveAsset.fulfilled]: (state) => {
      state.isCheckedAll = false;
      state.values.forEach((e) => (e.isChecked = false));
      state.unarchiveAssetStatus = "success";
    },
    [unarchiveAsset.rejected]: (state, { payload }) => {
      state.unarchiveAssetErrorMessage = payload.message;
      state.unarchiveAssetStatus = "error";
    },
  },
});

export const {
  refreshArchivedStatus,
  updateSearchTerm,
  sort,
  updatePage,
  setScrollPosition,
  checkValue,
  checkAllValues,
  resetArchivedState,
} = archivedSlice.actions;

export default archivedSlice.reducer;

const archivedState = (state) => state.archived;
// const getId = (_, id) => id;
export const selectArchivedIds = createSelector(archivedState, (asset) => {
  return asset.values.map((v) => v.id);
});
export const selectArchived = (state) => state.archived.values;
export const selectArchivedById = (state, assetId) => {
  return state.archived.values.find((v) => v.id === assetId);
};

// export const {
//   selectAll: selectArchived,
//   selectById: selectArchivedById,
//   selectIds: selectArchivedIds,
// } = archivedAdapter.getSelectors((state) => state.archived);
